
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.505 27.067l21.09 21.2c.64.61.23 3.61-.7 2.72-6.054-6.093-12.11-12.18-18.17-18.26 2.253 5.754 4.516 11.5 6.79 17.24.3.82-.4 3.77-1 2.23l-8.88-22.55-12.77-12.84c-.64-.64-.22-3.65.7-2.72l9.85 9.9c-1.874-4.78-3.75-9.553-5.63-14.32-.3-.81.39-3.77 1-2.23 2.566 6.547 5.14 13.09 7.72 19.63z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.044 32.557c1.808-.13 3.623-.13 5.43 0 2.72.18 3.99 2.22 4.09 4.79.01.368.03.767.05 1.187.17 3.61.413 8.775-3.95 9.213-.48 0-.975.012-1.474.024-3.782.09-7.834.188-8.046-4.804-.012-.3-.03-.623-.05-.962-.199-3.599-.5-9.046 3.95-9.448zm5.18 7.6a.911.911 0 00-.18-.48l-1.95 1.95c.79-.1 2.13-.62 2.13-1.47zm-4.74.04a.86.86 0 00.18.48l1.95-1.95c-.69.07-2.13.63-2.13 1.47zm-2.984.406c-.072 1.28-.155 2.737.934 3.544v-.04c.96.7 2.6.77 4.19.72-2.33-.17-3.52-2.49-3.52-4.62.01-1.87.93-3.91 2.72-4.48-.593-.03-1.187-.03-1.78 0-2.51.25-2.51 2.05-2.51 4 0 .275-.016.57-.034.877zm6.232 4.149c.706-.059 1.39-.115 1.932-.115v-.04c2.554-.252 2.535-1.94 2.514-3.787l-.004-.383c0-.273.014-.555.028-.841.066-1.337.135-2.739-1.208-3.489a6.05 6.05 0 00-3-.36 4.29 4.29 0 012.56 3.61c.076.277.11.564.1.85.002.266-.028.532-.09.79-.28 1.71-1.18 3.4-2.9 3.77l.068-.005z"}})])
          )
        }
      }
    